import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { LANGUAGES } from '../utils/languages';
import './LanguageModal.css';

/**
 * Language selection modal
 * Appears on first visit or when language is not cached
 */
function LanguageModal() {
  const { showLanguageModal, changeLanguage, t } = useTranslation();

  if (!showLanguageModal) return null;

  return (
    <div className="language-modal-overlay">
      <div className="language-modal">
        <h2>{t('chooseLanguage')}</h2>
        <div className="language-options">
          {LANGUAGES.map(lang => (
            <button
              key={lang.code}
              className="language-option"
              onClick={() => changeLanguage(lang.code)}
            >
              {lang.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LanguageModal;

